/** 재생 중 앨범 썸네일 위 — 3막대 이퀄라이저 (흰색) */
export function MiniPlayerEqualizer() {
  return (
    <svg
      className="soundpill-mini-player-eq"
      viewBox="0 0 24 20"
      width={24}
      height={20}
      aria-hidden
    >
      <rect className="soundpill-mini-player-eq__bar soundpill-mini-player-eq__bar--1" x="1" y="6" width="4" height="14" rx="2" fill="#fff" />
      <rect className="soundpill-mini-player-eq__bar soundpill-mini-player-eq__bar--2" x="10" y="2" width="4" height="18" rx="2" fill="#fff" />
      <rect className="soundpill-mini-player-eq__bar soundpill-mini-player-eq__bar--3" x="19" y="5" width="4" height="15" rx="2" fill="#fff" />
    </svg>
  );
}
